"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdjustmentRowComponent = void 0;
const core_1 = require("@angular/core");
const account_1 = require("./account");
let AdjustmentRowComponent = class AdjustmentRowComponent {
    dataInputUpdate(data, header) {
        if (this.accountHour) {
            Object.assign(data, { hour: this.accountHour.hour });
        }
    }
};
exports.AdjustmentRowComponent = AdjustmentRowComponent;
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", account_1.Account)
], AdjustmentRowComponent.prototype, "account", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Boolean)
], AdjustmentRowComponent.prototype, "isHourly", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Array)
], AdjustmentRowComponent.prototype, "columnHeaderKeys", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], AdjustmentRowComponent.prototype, "columnHeaderMap", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], AdjustmentRowComponent.prototype, "accountHour", void 0);
exports.AdjustmentRowComponent = AdjustmentRowComponent = __decorate([
    (0, core_1.Component)({
        selector: '[adjustment-row]',
        templateUrl: 'app/adjustment-row.component.html',
        styleUrls: ['styles/adjustment.component.css']
    })
], AdjustmentRowComponent);
//# sourceMappingURL=adjustment-row.component.js.map